<script lang="ts">
  import { onMount } from "svelte"
  import { xhr, toast } from "$app/utils"
  import Honeybadger from "$app/utils/honeybadger"
  import { signupStore } from "$app/signupstore.svelte"

  interface Props {
    onvalidating: (validating: boolean) => void
    onupdate?: (coupon: any) => void
  }

  let { onvalidating, onupdate = () => {} }: Props = $props()

  let validate_btn = $state<HTMLButtonElement>(null)
  let validating = $state(false)
  let checked_coupon = $state(false)

  /**
   * Review valid coupon
   */
  async function checkCoupon(): Promise<void> {
    signupStore.coupon.id = signupStore.coupon.id?.trim()

    if (signupStore.coupon.id?.length > 0) {
      checked_coupon = true
      validating = true
      onvalidating(validating)

      try {
        const resp = await xhr.get<StripeCouponType>(
          `/stripe/coupon/${signupStore.coupon.id.trim()}`
        )
        signupStore.coupon = { ...resp.data, id: signupStore.coupon.id }

        if (!resp.data.id) {
          toast("Coupon code is invalid", "error")
        } else {
          toast("Valid Coupon code", "success")
        }
        onupdate(resp.data)
      } catch (e: any) {
        if (typeof Honeybadger.notify !== "undefined") {
          Honeybadger.notify(e)
        }
        toast(
          "There was an error validating the coupon code try again",
          "error"
        )
      } finally {
        validating = false
        onvalidating(validating)
      }
    } else {
      onupdate({})
    }
  }

  function focusCoupon() {
    validate_btn?.classList.remove("btn-secondary")
    validate_btn?.classList.add("btn-primary")
  }

  onMount(() => {
    signupStore.coupon.id && !checked_coupon && checkCoupon()
  })
</script>

<div>
  <div class="flex items-center gap-1">
    <input
      type="text"
      name="subscription[stripe_coupon]"
      bind:value={signupStore.coupon.id}
      class="input"
      autocomplete="off"
      class:!bg-red-100={signupStore.coupon.id !== "" &&
        signupStore.coupon.valid === false}
      class:!bg-green-50={signupStore.coupon.id !== "" &&
        signupStore.coupon.valid === true}
      placeholder="Coupon Code"
      onblur={checkCoupon}
      onfocus={focusCoupon}
      style="height:2.3rem"
    />
  </div>
</div>
